import {
	ImagePerformanceQueryParamKey,
	ImagePerformanceQueryParamValue,
} from '~utils/performance-logging';

export const enrichUrlWithLoadingMarker = (url: string) => {
	if (url.includes('imagedelivery')) {
		return url;
	}
	const newUrl = new URL(url);
	newUrl.searchParams.append(
		ImagePerformanceQueryParamKey,
		ImagePerformanceQueryParamValue
	);
	return newUrl.toString();
};
